/*@ngInject*/
const UIDrawerSlideDirective = function ($rootScope, $window, coreConstant, $timeout) {

    var linkFunction = function ($scope, $elm) {

        var window = $($window),
            element = $($elm),
            updateNavigationBasedOnWindowSize;

        function openDrawer() {
            element.addClass('open is-animated');
            element.removeClass('closed');
        }

        function closeDrawer() {
            element.addClass('closed is-animated');
            element.removeClass('open');
        }

        function removeAnimationClass(event) {
            var target;

            if (element.hasClass('is-animated')) {
                element.removeClass('is-animated');

                target = $(event.target);

                if (target.hasClass('navigation')) {
                    $rootScope.$broadcast(coreConstant.NAVIGATION_DRAWER_TOGGLED);
                }
            }
        }

        function updateDrawerState() {
            if ($scope.submissionViewModel.isDrawerOpen) {
                openDrawer();
            } else {
                closeDrawer();
            }
        }

        updateNavigationBasedOnWindowSize = _.debounce(function () {
            if ($scope.isLargeScreen) {
                if (window.width() < 1200) { // 992, 768, 1200
                    $scope.submissionViewModel.isDrawerOpen = false;
                    closeDrawer();
                }
                else {
                    $scope.submissionViewModel.isDrawerOpen = true;
                    openDrawer();
                }

                $timeout(function () {
                }, 0);
            }
            else {
                $scope.submissionViewModel.isDrawerOpen = false;
            }
        }, 10);


        $scope.$watch('submissionViewModel.isDrawerOpen', updateDrawerState);

        element.on('transitionend webkitTransitionEnd oTransitionEnd', removeAnimationClass);
        window.on('resize.uiDrawerSlide', updateNavigationBasedOnWindowSize);

        $scope.$on('$destroy', function () {
            element.off('transitionend webkitTransitionEnd oTransitionEnd', removeAnimationClass);
            window.off('resize.uiDrawerSlide', updateNavigationBasedOnWindowSize);
        });

        updateNavigationBasedOnWindowSize();
        updateDrawerState();
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('gw-um-submission')
    .directive('uiDrawerSlide', UIDrawerSlideDirective);
